import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { serviceSettingsRoute } from '../route';

export const advisorRightsRoute = createRoute({
	getParentRoute: () => serviceSettingsRoute,
	path: '/advisor-rights',
	component: lazyRouteComponent(
		() => import('./AdvisorRightsPage'),
		'AdvisorRightsPage',
	),
});
